
  import { Component, Vue } from 'vue-property-decorator';
  import settings from '../config';
  @Component
  export default class PrivacyPolicy extends Vue {
    public translationSection: string = '';

    public created() {
      this.translationSection = settings.VUE_APP_TRANSLATION_SECTION;
    }
  }
